import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import BulkEmails from './BulkEmails';
import GenerateBlog from './GenerateBlog';
import LinkedIntoTwitter from './LinkedIntoTwitter';
import GenerateLinkedInPost from './GenerateLinkedInPost';
import FEDealIntel from './FEDealIntel';
import CrmSearch from './CrmSearch';
import HubspotBuyerSearch from './HubspotBuyerSearch';

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FEDealIntel />} />
        <Route path="/fetch_bulk_emails" element={<BulkEmails />} />
        <Route path="/generate_blog" element={<GenerateBlog />} />
        <Route path="/linkedin_to_twitter_converter" element={<LinkedIntoTwitter />} />
        <Route path="/generate_linkedin_post" element={<GenerateLinkedInPost />} />
        <Route path="/buyer_list" element={<App />} />
        <Route path="/crm_search" element={<CrmSearch />} />
        <Route path="/hubspot_buyer_search" element={<HubspotBuyerSearch />} />
        <Route path="*" element={<div>404 - Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
